<template>
    <div>
        <el-popover
            v-model="isShowPopover"
            :placement="placement"
            :width="popoverWidth"
            trigger="click">

            <el-input style="margin-bottom: 10px;" clearable size="mini" v-model="keyword" placeholder="请输入查询条件" v-on:input="inputMethod" :disabled="tableLoading"></el-input>

            <el-table :data="tableData" @row-click="selectData" height="250" border style="width: 100%" header-cell-style="background: #eee;color:#999;" v-loading="tableLoading">
                <el-table-column show-overflow-tooltip align="center" v-for="(title,index) in tableTitle" :key="index" :property="title.titleId" :label="title.titleText"></el-table-column>
            </el-table>

            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                pager-count="5"
                small="true"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>

            <div v-if="msg" slot="reference" class="selectButton" :style="{ width: inputWidth }">
                <el-tooltip v-if="showToolTip" class="item" effect="dark" :content="msg" placement="top-start">
                    <div class="customTxtBox">{{ msg }}</div>
                </el-tooltip>
                <div class="selectButtonContent" v-if="!showToolTip">
                    {{ msg }}
                    <i class="el-icon-error" @click="clean"></i>
                </div>
            </div>
            <div v-else slot="reference" class="selectButton popover_placeholder" :style="{ width: inputWidth }">
                {{placeholder}}
            </div>
        </el-popover>
    </div>
</template>

<script>
    export default {
        model: {    // 使用model，prop属性说，我要将msg作为该组件被使用时（此处为本组件被父组件调用）v-model能取到的值，event说，我this.$emit('cc',修改的值) 的时候，参数的值就是父组件v-model收到的值。
            prop: 'msg',
            event: 'cc'
        },
        props:{
            msg:'',
            oldData: {
            	type:String,
            },
            placeholder:{
            	type:String,
                default:"请选择"
            },
            showToolTip: {
                type: Boolean,
                default: false
            },
            tableLoading: {
                type: Boolean,
                default: false
            },
            placement:{
            	type:String,
                default:"bottom-start"
            },
            popoverWidth:{
            	type:String,
                default:"350"
            },
            inputWidth: {
            	type:String,
                default:"100%"
            },
            tableTitle:{   //表格title
                type:Array,
                require:true
            },
            tableData:{     //表格数据
                type:Array,
                require:true
            },
            selectField:{   //选择表格数据的绑定字段
                type:String,
                require:true
            },
            pageSize:{
                type:Number,
                require:false,
                default:5
            },
            pageIndex:{
                type:Number,
                require:true,
                default:1
            },
            total:{
                type:Number,
                require:true,
                default:5
            },
            inputSearch:{
                type:Function,
                default:function(){
                    console.log('输入查询默认事件！');
                }
            }
        },
        data(){
            return{
                isShowPopover:false, // popover的show/hide状态
                keyword:'',
            }
        },
        watch: {
            isShowPopover () {
                if (this.isShowPopover) {
                  this.keyword = ''
                  this.inputMethod()
                }
            }
        },
        methods:{
            // 切换页数
            handleCurrentChange(val){
                let params = {
                    pageIndex:val,
                    pageSize:this.pageSize,
                    keyword:this.keyword,
                    type:'web'
                }
                this.inputSearch(params);
            },
            // 输入查询
            inputMethod(){
                let params = {
                    pageIndex:1, // 输入查询都是从第一页开始，所以为固定值
                    pageSize:5,
                    keyword:this.keyword,
                    type:'web'
                }
                this.inputSearch(params);
            },
            // 选择数据
            selectData(val){
                this.$emit('cc', val[this.selectField]);
                this.$emit('getRowData', val);
                if(this.oldData && this.oldData != val[this.selectField]){
                    this.$emit('valueChange');
                }
                this.isShowPopover = false;
            },
            clean() {
                this.$emit('cc', "");
            }
        }
    }
</script>

<style>
	.popover_placeholder{
		color: #CCCCCC;
		font-size: 11px;
		background-color: white;
	}
    .selectButton{
        border:1px solid #dedede;
        border-radius: 4px;
        /* width:260px; */
        height: 40px;
        display: flex;
        align-items: center;
        line-height: 40px;
        padding:0 10px;
        background-color: white;
    }
    .selectButtonContent {
        font-size: 12px;
        position: relative;
    }
    .selectButtonContent .el-icon-error {
        position: absolute;
        right: 0;
        top: 6px;
        font-size: 13px;
        color: #c0c4cc;
        display: none;
    }
    .selectButtonContent .el-icon-error:hover {
        color: #666;
    }
    .selectButtonContent:hover .el-icon-error {
        display: block;
    }
    .customTxtBox {
        width: 100%;
        height: 40px;
        line-height: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>





// WEBPACK FOOTER //
// src/components/popoverTable.vue